import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f7a6eec&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4f7a6eec&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a6eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7a6eec')) {
      api.createRecord('4f7a6eec', component.options)
    } else {
      api.reload('4f7a6eec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f7a6eec&scoped=true&", function () {
      api.rerender('4f7a6eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/collectFees/index.vue"
export default component.exports